export default function AboutMe() {
    return (
      <div className="AboutMe">
          <h1>About Me</h1>
        <div className="Header">
          <p>Connecting the dots between Art, Science and Technology</p>
        </div>
        <div className="MainDescription">
          <p>Hey there! Glad you could stop by. My name is Chrysalis or Chrys (pronounced as Chris) for short.</p>
          <p>My passion for coding was sparked when I joined Saturday Kids as a Programming Instructor back in 2018 while I was still studying. Through this experience, I was able to develop a deep skill set in simplifying programming concepts that I used to teach students, resulting in enabling my students to feel that programming is a lot more accessible. That role inspired me to learn more about programming and I really became passionate about finding ways to simplify programming concepts and ideas. </p>
        </div>
      </div>
    );
  }
  
  